import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./Slices/User";
import cableSlice from "./Slices/Cables";
import storeSlice from "./Slices/Stores";
import vendorSlice from "./Slices/Vendors";
import selectSlice from "./Slices/Select/Select";

export const store = configureStore({
    reducer: {
        user: userSlice,
        cables: cableSlice,
        stores: storeSlice,
        vendor : vendorSlice,
        select : selectSlice
    }
}) 